/*
 * Componente per gestire i permessi Google
 * Riceve in input un array di oggetti del tipo

 //lista su https://developers.google.com/identity/protocols/oauth2/scopes
    scopes: [
      {
        name: "Google Calendar",
        url: "https://www.googleapis.com/auth/calendar",
        authorized: false,
      },
    ],

 * Il suo compito è quello di verificare l'esistenza e validità del token
 * richiedere eventualmente un nuovo token o eliminarlo dal db.

*/
<template>
  <v-container>
    <v-card class="mt-5">
      <v-card-title class="primary white--text"
        >Lista Permessi Richiesti</v-card-title
      >
      <v-card-text>
        <v-list>
          <v-list-item v-for="scope in scopes" :key="scope.url">
            <v-list-item-icon>
              <v-icon>mdi-google</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="scope.name"></v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn v-show="!showLoader" icon>
                <v-icon :color="scope.authorized ? 'green' : 'grey'">{{
                  scope.authorized ? "mdi-check" : "mdi-alert-octagon"
                }}</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-card-text>
      <v-card-actions class="secondary white--text">
        <v-row>
          <v-col cols="8" class="pl-6">
            <div class="overline">
              <v-icon>mdi-information</v-icon> Stato Richiesta
            </div>
            <div>
              {{ access_token_status ? access_token_status.message : "" }}
            </div></v-col
          >
          <v-col cols="4" class="d-flex justify-end pr-5">
            <v-btn
              @click="init_access_token_request"
              v-show="
                !showLoader &&
                access_token_status &&
                access_token_status.code < 2000
              "
            >
              Autorizza <v-icon right dark> mdi-google </v-icon>
            </v-btn>

            <v-btn
              @click="remove_access_token_db"
              v-show="
                !showLoader &&
                access_token_status &&
                access_token_status.code >= 2000
              "
            >
              Elimina Token <v-icon right dark> mdi-close </v-icon>
            </v-btn>

            <v-progress-circular
              v-show="showLoader"
              color="primary"
              indeterminate
            ></v-progress-circular>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>

    <v-row>
      <!--vrow necessaria per la width 100%-->
      <v-snackbar
        app
        v-model="snackbar_show"
        type="warning"
        width="100%"
        color="info"
        vertical="vertical"
        >{{ snackbar_text }}</v-snackbar
      >
    </v-row>
  </v-container>
</template>


<script>
//import moment from "moment";
import mj_axios from "@/mj_axios.js";

export default {
  name: "MjGooglePermissions",
  props: { scopeProp: { type: Array } },
  created() {
    if (this.$route.query.auth_code) {
      const auth_code = this.$route.query.auth_code;
      const scopes = this.$route.query.scopes.split(" ");
      this.finalize_access_token_request(auth_code, scopes).then(
        this.get_access_token_status
      );
    } else {
      this.get_access_token_status();
    }
  },
  computed: {
    scope_urls: function () {
      return this.scopes.map((scope) => scope.url);
    },
  },
  data: function () {
    return {
      scopes: this.scopeProp,
      access_token_status: null,
      showLoader: true,
      snackbar_show: false,
      snackbar_text: "",
    };
  },
  methods: {
    get_access_token_status: function () {
      this.showLoader = true;
      mj_axios
        .get(`/api/user/google/get_access_token_status`, {
          params: { scopes: JSON.stringify(this.scope_urls) },
        })
        .then((response) => {
          if (response && response.data) {
            this.access_token_status = response.data;
            if (this.access_token_status.scopes) {
              const scopes_url = this.access_token_status.scopes.split(" ");
              this.scopes = this.scopes.map((scope) => {
                scope.authorized = scopes_url.includes(scope.url);
                return scope;
              });
            }
          }
        })
        .catch(() => {
          this.snackbar_show = true;
          this.snackbar_text = "Errore nel get Access token status";
        })
        .then(() => {
          this.showLoader = false;
        });
    },
    finalize_access_token_request: function (auth_code, scopes) {
      return new Promise((resolve, reject) => {
        this.showLoader = true;
        mj_axios
          .get(
            `/api/user/google/finalize_request_authorization?auth_code=${auth_code}&scopes=${JSON.stringify(
              scopes
            )}`
          )
          .then(() => {
            this.$router.replace(
              this.$route.path
                .replace(this.$route.params.auth_code, "")
                .replace(this.$route.params.scopes, "")
            );
            resolve();
          })
          .catch(() => {
            reject();
          })
          .then(() => {
            this.showLoader = false;
          });
      });
    },
    init_access_token_request: function () {
      if (this.access_token_status.authUrl) {
        window.location = this.access_token_status.authUrl;
      } else {
        this.snackbar_show = true;
        this.snackbar_text =
          "Non ho un url di autorizzazione. Prova a ricaricare la pagina";
      }
    },
    remove_access_token_db: function () {
      mj_axios
        .delete("/api/user/google/remove_access_token_db")
        .then((response) => {
          if (response.data.message) {
            this.snackbar_text = response.data.message;
            this.snackbar_show = true;
          }

          this.get_access_token_status();
        })
        .catch(() => {})
        .then(() => {
          this.showLoader = false;
        });
    },
  },
};
</script>
